export default [
  {
    path: "/bloqueioPecas",
    name: "BloqueioPecas",
    component: () => import("../views/index"),
    meta: { requiresAuth: true },
  },
];
